export const PayeeTypes = {
  company: 'Company',
  individual: 'Individual'
};

export const PayeeFormNames = {
  payeeType: "Payee Type",
  countryOfIncorporation: "Country of Incorporation",
  countryOfResidency: "Country of Residency",
  dateOfBirth: "Date of Birth",
  address: "Address",
  postCode: "Post Code",
  stateOfIncorporation: "State of Incorporation",
  stateOfResidency: "State of Residency",
  payee: "Payee Name",
  givenName: "Given Name(s)",
  familyName: "Family Name",
  addressLine1: "Address Line 1",
  addressLine2: "Address Line 2",
  addressLine3: "Address Line 3",
  city: "City"
}

export const MaxAddressLength = 50;

export const MaxPostCodeLength = 20;

export const MaxPayeeLengthCompany = 50;

export const MaxPayeeLengthIndividual = 25;

export const MaxCityLength = 50;

export const CountriesWithStatesIso = ["US", "CA"];

export const OrganisationDataSources = {
  MDM: "MDM",
  Orbis: "Orbis",
  New: "New"
};

export const ErrorMessages = {
  getMdmCompanyByOrbisId : "Error occurred. MDM Company is not retrieved by orbis Id.Please, try again later.",
  submitPayee : "Payee Creation is failed. Errors occurred",
  getTimeflowUnifiConfig : "Error occurred while getting Timeflow Unifi config"
}